<li class="nav-item no-padding">

    <div class="nav-link no-margins cursor-pointer text-black">
        <div *ngIf="profile && showGift" data-toggle="tooltip" title="Billetera" style="width: 32px;">
            <a class="text-black" (click)="goToGivis()">
                <i class="mdi mdi-gift-outline" style="font-size: 28px;"></i>
            </a>
        </div>
        <!-- <div *ngIf="profile" data-toggle="tooltip" title="Cerrar sesión">
            <a class="text-purple font-12" (click)="onLogout()">
                <div class="text-center"><i class="fa fa-power-off font-20"></i></div>
                <div class="font-8">Cerrar sesión</div>
            </a>
        </div>

        <div *ngIf="!profile && !hideLogin" data-toggle="tooltip" title="Iniciar sesión">
            <a class="text-purple font-12" (click)="onLogin()">
                <div class="text-center"><i class="fa fa-sign-in font-20"></i></div>
                <div class="font-8">Iniciar sesión</div>
            </a>
        </div> -->
    </div>
</li>
<!-- End Profile -->
